import { Space } from "antd";
import { OpacitySlider } from "../../../controls/OpacitySlider";
import { PaletteResponse } from "pages/media/types";
import { PlaceholderColorPicker } from "../../../controls/PlaceholderColorPicker";
import { isGradient } from "../../../../helpers/itemsHelper";
import type { GradientDefinition } from "types";
import { DEFAULT_COLOR } from "../../../../constants";

export const HeaderBackgroundColorFeature = ({
  background,
  palette,
  onChange,
}: {
  background?: string | GradientDefinition;
  palette?: PaletteResponse;
  onChange: (color?: string | GradientDefinition) => void;
}) => {
  return (
    <>
      <Space>
        <PlaceholderColorPicker
          shape="square"
          value={background}
          onChangeComplete={onChange}
          palette={palette}
          mode={["single", "gradient"]}
          disabledAlpha
          showText={false}
          triggerProps={{
            $backgroundColor: "transparent",
          }}
        />
        {background && (
          <OpacitySlider
            hexColor={isGradient(background) ? DEFAULT_COLOR : background}
            disabled={isGradient(background)}
            palette={palette}
            onChange={(hexColorWithOpacity: string) =>
              background && onChange(hexColorWithOpacity)
            }
          />
        )}
      </Space>
    </>
  );
};
